import { ConciergeBell, HandPlatter, Sparkles, Sprout } from 'lucide-react';
import React, { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { sortByOrder } from 'src/helpers';
import { useGetPhoneBookFromFirestore, useQueryHelper } from 'src/queries';
import { useLanguageState, useOrganizationState } from 'src/state';

import { Error, Spinner } from '../../components';
import { PhoneBookCard } from './components';
import { Container, Title } from './PhoneBook.styled';

export const PhoneBook: FC = () => {
  const { organizationData } = useOrganizationState();
  const { language: currentLang } = useLanguageState();
  const phonebookCollections = useGetPhoneBookFromFirestore(organizationData.hotel);
  const { data: phonebook, refetch } = phonebookCollections;
  const sortedPhonebook = sortByOrder(phonebook);
  const { isLoading, isError } = useQueryHelper({ queries: [phonebookCollections] });
  const { t } = useTranslation();

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const getPhoneBookIcon = (type: string) => {
    switch (type) {
      case 'RECEPTION':
        return <ConciergeBell color="#C18244" />;
      case 'ROOM_SERVICE':
        return <HandPlatter color="#C18244" />;
      case 'HOUSEKEEPING':
        return <Sparkles color="#C18244" />;
      case 'SPA':
        return <Sprout color="#C18244" />;
      default:
        return <ConciergeBell color="#C18244" />;
    }
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleCall = (phoneNumber: string) => {
    window.location.href = `tel:${phoneNumber}`;
  };

  if (isLoading) {
    return (
      <Spinner global />
    );
  }

  if (isError) {
    return <Error info errorTitle="Brak dostępnych numerów" action={refetch} />;
  }

  return (
    <>
      <Helmet>
        <title>Hotelspot | Książka telefoniczna</title>
        <meta name="description" content="Hotelspot - Książka telefoniczna" />
      </Helmet>
      <Container>
        <Title>{t('phone_book_screen.title')}</Title>
        {(!sortedPhonebook || sortedPhonebook?.length === 0) && (
        <Error
          info
          errorTitle="Brak dostępnych numerów"
          errorMessage="Nie dodano numerów kontaktowych"
        />
        )}
        {sortedPhonebook && sortedPhonebook?.map((item) => (
          <PhoneBookCard
            key={item.id}
            icon={getPhoneBookIcon(item.type)}
            title={item.title[currentLang]}
            action={() => handleCall(item.number)}
            description={item.description[currentLang]}
            isInternal={item.isInternal}
            number={item.number}
          />
        ))}
      </Container>
    </>
  );
};
